import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import filterList from '../../../common/actions/lists';
import { parseQuery } from '../../../common/services/parseQuery';
import { IRootState } from '../../../typings';
import { addProduct, fetchProducts } from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  filterList,
  fetchProducts,
  addProduct,
};

const mapStateToProps = (state: IRootState, ownProps: IOwnProps) => {
  return {
    me: state.me,
    products: state.products.list,
    pagination: state.products.pagination,
    fetching: state.products.fetching,
    total: state.products.totalItems,
    query: parseQuery(ownProps.location.search),
  };
};

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
